export const personas = {
  paging: { total: 2, count: 10, totalPages: 1, currentPage: 0 },
  personas: [
    {
      personaId: '5e31480f-7b8e-450e-8a72-3b941df64883',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
      title: '24012023_TestSegment',
      description: '14012023_TestTag',
      icon: '',
      roles: null,
      goals: null,
      challenges: null,
      createdBy: 'd2fcc537-179f-44cc-9c14-ba5297ef4beb',
      createdOn: '2023-01-24T09:34:03.000+00:00',
      rules: {
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValue:
          '{"attributeName":"14012023_TESTTAG","attributeValues":["TRUE"],"dataType":"COLLECTION"}',
        expressionName: 'EXTENDED_ATTRIBUTES',
        expressoinFormat:
          'EXTENDED_ATTRIBUTES:EQ:{"attributeName":"14012023_TESTTAG","attributeValues":["TRUE"],"dataType":"COLLECTION"}',
        extendedAttributes: { attributeTitle: '14012023_TestTag' },
        logicType: null,
        childNodes: null,
      },
      active: true,
    },
    {
      personaId: '0812e12e-21ad-4988-b413-82b2392385ff',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
      title: 'AAAA ---- Test1',
      description: 'AAAA ---- Test1',
      icon: '',
      roles: null,
      goals: null,
      challenges: null,
      createdBy: 'b826eaae-ea4a-49d1-80fa-53ef65a61c03',
      createdOn: '2023-04-11T06:46:17.000+00:00',
      rules: {
        ruleType: 'EXPRESSION',
        operator: null,
        expressionValue: 'MALE',
        expressionName: 'GENDER',
        expressoinFormat: 'GENDER:null:MALE',
        extendedAttributes: null,
        logicType: null,
        childNodes: null,
      },
      active: true,
    },
  ],
};
